import { useTranslation } from 'react-i18next';
// Allows for translation of TranslationString GQL type
export function useDynamicTranslation(ns, options) {
    var translationResponse = useTranslation(ns, options);
    var dynamicTranslation = function (translatedString) {
        var defaultText = translatedString.defaultText, namespace = translatedString.namespace, translationKey = translatedString.translationKey;
        if (!translationKey) {
            return defaultText;
        }
        return translationResponse.t(translationKey, {
            ns: namespace !== null && namespace !== void 0 ? namespace : undefined,
            defaultValue: defaultText
        });
    };
    return Object.assign(translationResponse, { dt: dynamicTranslation });
}
